export enum ReturnsRoutePathsEnum {
  REQUEST_RETURN_LABEL_ORG_HASH = 'request-return-label/:orgHash',
  REQUEST_RETURN_LABEL_TOKEN = 'request-return-label/token/:token',
  RETURN = 'returns/:returnCaseId',
  RETURNS = 'returns',
}
